export default __webpack_public_path__ + "static/media/IMG5846.fe6260e2.jpg";